import type { Manifest } from '../shared/types';
import type { ScriptAsset } from '../utils/asset-loaders';

export function createAssetEntry(
  manifest: Manifest,
  type: ScriptAsset['type']
): ScriptAsset | undefined {
  const path = manifest[type];
  return path ? { url: manifest.baseURL + path, type } : undefined;
}

export function createStyleEntry(manifest: Manifest): ScriptAsset | undefined {
  return createAssetEntry(manifest, 'style');
}

export function createScriptEntry(
  manifest: Manifest
): ScriptAsset & { exposed: string } {
  const entry = createAssetEntry(manifest, 'script');

  // `script` is `required: true` in schema.ts's ManifestSchema, so `entry` is
  // always defined once a value has passed validateAppManifest and become a
  // real `Manifest` — this mirrors what the original code assumed too (it
  // wrote `entry.exposed = ...` unconditionally, with no check at all).
  if (!entry) {
    throw new Error('createScriptEntry: manifest.script was not present');
  }

  return { ...entry, exposed: manifest.exposed };
}
